
<div style="width:500px;">
  <div style="width:99%;">
  <span> <button class="btn btn border" (click)="saveCause()" [disabled]="!form.dirty">Spara</button>  <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br><hr />
 <form [formGroup]="form">

  <!--div class="row">
 <div class="col-md-2">
   <label>
     Id
   </label>
   <input id="id" type="text" class="form-control form-control-sm" formControlName="id"
     readonly>
   </div>
  </div-->

  <div class="row">
  <div class="col-md-6">
     <label>
       Namn
     </label>
     <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
   </div>

  </div>

  <div class="row">
   <div class="col-md-8">
     <label>
      Beskrivning
     </label>
     <input id="description" type="text" class="form-control form-control-sm" formControlName="description">
   </div>
  </div>

   </form>
   </div>
 </div>




